/**
 * For doing promise based stuff on links aka (Stats)
 * @param promisable {function} some function that can be thenable
 * @param time {Number} default time to wait
 * @example <a href="/" onClick={handleLinkClick(somePromiseReturningFn)} />
 * @example <div data-href="/" onClick={handleLinkClick(somePromiseReturningFn)} />
 */
const handleLinkClickSideEffect = (promisable, time = 300) => e => {
	const isLink = e.currentTarget.tagName === 'A';
	const isNewTab = (
		e.which === 2 ||
			e.metaKey ||
			e.ctrlKey ||
			e.currentTarget.target === '_blank'
	);

	if (isLink && !isNewTab) {
		e.preventDefault();
	}

	let timeout;
	const href = e.currentTarget.href || e.currentTarget.dataset.href;

	const followLink = () => {
		timeout && clearTimeout(timeout);
		if (href && !isNewTab) {
			window.location = href;
		}
	};

	promisable().then(followLink, followLink);
	// Fallback to just follow link after 300ms
	timeout = setTimeout(followLink, time);
};

export default handleLinkClickSideEffect;
